<div class="row page-header">
    <div class="col-12">
        <h1>Safety Feedback <small>Safety feedback, corrective actions, and near-miss reports</small></h1>
    </div>
</div>

<div [hidden]="isInitialLoading">
    <ul ngbNav [(activeId)]="activeTab" (activeIdChange)="tabChanged()" class="nav-tabs mb-3">
        <li [ngbNavItem]="0" [destroyOnHide]="false">
            <a ngbNavLink>Dashboard</a>
        </li>
        <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>Records</a>
        </li>
    </ul>

    <div [hidden]="!isDashboardTab">
        <app-safety-feedback-dashboard></app-safety-feedback-dashboard>
    </div>

    <div [hidden]="!isRecordsTab">
        <app-safety-feedbacks></app-safety-feedbacks>
    </div>
</div>
